import BaseCollapse from './Collapse';

// EXPORT
export const Collapse = BaseCollapse;
export type { CollapseProps } from './Collapse.interface';
